module.exports = __webpack_public_path__ + "img/devin-600x600.b505263f.png";